<template>
  <v-container class="chartist-section" grid-list-md text-xs-center>
    <v-layout row wrap>

      <v-flex v-for="i in 3" :key="`4${i}`" sm4 xs12>
        <v-card dark color="primary">
          <v-card-text class="px-0">
            <chartist-card
              msg="Line Chart"
              :data="dailySalesChart.data"
              :options="dailySalesChart.options"
              color="info"
              type="Line"
            />
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex v-for="i in 2" :key="`6${i}`" sm6 xs12>
        <v-card dark color="secondary">
          <v-card-text class="px-0">
            <chartist-card
              msg="Bar Chart"
              :data="emailsSubscriptionChart.data"
              :options="emailsSubscriptionChart.options"
              :responsive-options="emailsSubscriptionChart.responsiveOptions"
              color="red"
              type="Bar"
            />
          </v-card-text>
        </v-card>
      </v-flex>
      
    </v-layout>
  </v-container>
</template>


<script>

export default {
  name: 'chartist-section',
  data () {
    return {
      dailySalesChart: {
        data: {
          labels: ["M", "T", "W", "T", "F", "S", "S"],
          series: [[12, 17, 7, 17, 23, 18, 38]]
        },
        options: {
          lineSmooth: this.$chartist.Interpolation.cardinal({
            tension: 0
          }),
          low: 0,
          high: 50, // creative tim: we recommend you to set the high sa the biggest value + something for a better look
          chartPadding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
          }
        }
      },
      emailsSubscriptionChart: {
        data: {
          labels: [
            "Ja",
            "Fe",
            "Ma",
            "Ap",
            "Mai",
            "Ju",
            "Jul",
            "Au",
            "Se",
            "Oc",
            "No",
            "De"
          ],
          series: [[542, 443, 320, 780, 553, 453, 326, 434, 568, 610, 756, 895]]
        },
        options: {
          axisX: {
            showGrid: false
          },
          low: 0,
          high: 1000,
          chartPadding: {
            top: 0,
            right: 5,
            bottom: 0,
            left: 0
          }
        },
        responsiveOptions: [
          [
            "screen and (max-width: 640px)",
            {
              seriesBarDistance: 5,
              axisX: {
                labelInterpolationFnc: function(value) {
                  return value[0];
                }
              }
            }
          ]
        ]
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .container.grid-list-md .layout .flex {
    padding: 15px;
    height: 400px;
  }
</style>
